<script setup lang="ts">
import type { HeadingElementProps } from "./HeadingElementProps";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import ScrollAnimation from "@/views/blocks/shared/section/animations/ScrollAnimation.vue";
import { computed } from "vue";
import HorizontalSpacing from "@/views/blocks/shared/section/layout/spacing/HorizontalSpacing.vue";

const props = defineProps<{
    block: PageBlock<HeadingElementProps>;
    scrollAnimationType?: ScrollAnimationType;
}>();

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);
</script>

<template>
    <ScrollAnimation :type="scrollAnimationType">
        <div
            :id="block.webId"
            :style="{
                backgroundColor: styleValues.background,
            }"
        >
            <HorizontalSpacing
                :class="[
                    dataValues.formatting.data.paddingTop,
                    dataValues.formatting.data.paddingBottom,
                ]"
            >
                <div class="mx-auto max-w-2xl lg:max-w-7xl">
                    <EditableElement
                        :blockId="block.id"
                        field-name="heading"
                        v-if="!dataValues.heading.isHidden"
                    >
                        <Heading
                            :text="dataValues.heading.data.text"
                            :tag="dataValues.heading.data.tag"
                            :text-color="styleValues.text"
                            :class="[
                                dataValues.formatting.data.elementAlign,
                                dataValues.formatting.data.maxWidth,
                                dataValues.formatting.data.textAlign,
                                dataValues.formatting.data.textSize,
                            ]"
                        />
                    </EditableElement>
                </div>
            </HorizontalSpacing>
        </div>
    </ScrollAnimation>
</template>
